import React from 'react';
import "./sass/express-option.scss";
import Verbiage from '../../verbiage';
function ExpressOption({
  selected=true,
  select=()=>{},
  details,
  fulfillmentDetails={}
}) {
  const enabled = details.enabled;
  let cardClasses = "expressTile card card-container card-background ";
  cardClasses+=(selected?"card-selected ":"card-unselected ");
  cardClasses+=(enabled?"card-enabled ":"card-unselected ");

  const displayPrice = details.estimatedDeliveryCharge;
  const timeLine = (details.storeDeliveryTimeline==="today")?"Today":((details.storeDeliveryTimeline==="tomorrow")?"Tomorrow":"");
  const displayFree = details.isFreeDelivery;
  const getItByMessage = fulfillmentDetails.showBodfsCovidAlert ?
        <div className="dai_tileMessage express-delivery__message">
            <div>
                As soon as&nbsp;
            </div>
            <div className="express-delivery__message--bold">
                Tomorrow
            </div>
        </div> :
        <div className="dai_tileMessage express-delivery__message">
            <div>
                Get it&nbsp;
            </div>
            <div className="express-delivery__message--bold">
                {timeLine}
            </div>
        </div>;
  return (
    <div className={cardClasses} onClick={()=>{if(enabled){select('EXPRESS')}}}>
      <div className={"express-delivery__wrapper " + (enabled?"":"express-delivery__wrapper--disabled")}>
          <div className="">
              <div className={"express-delivery__icon express-" + (enabled?"true":"false")}></div>
              <div className="tile-heading dai_tileHeading express-delivery__heading">
                {fulfillmentDetails.showBodfsCovidAlert?Verbiage.EXPRESS_TILE_HEADING_COVID:Verbiage.EXPRESS_TILE_HEADING}
              </div>
          </div>
          {enabled && timeLine && (
            <div className="express-delivery__message-wrapper">
                {getItByMessage}
            </div>
          )}
          {enabled && !timeLine &&(
            <div className="express-delivery__message-wrapper">
                <div className="dai_tileMessage express-delivery__message">
                    {fulfillmentDetails.showBodfsCovidAlert?"":Verbiage.EXPRESS_TILE_MSG_NO_DATE}
                </div>
            </div>
            )}
          {!enabled && (
            <div className="express-delivery__message-wrapper">
                <div id="unavailable-text" className="dai_tileMessage express-delivery__message express-delivery__message--bodfs-unavailable dai_expressTileMessage">
                    Not available for this item
                </div>
            </div>
            )}
      </div>
        {displayFree ? <div className="fulfillment__price-wrapper card-messaging-bottom">
            <span className="u__text--success dai_tilePrice">FREE</span>
        </div> : <div className="fulfillment__price-wrapper card-messaging-bottom">
            <span className="tile-price dai_tilePrice">{displayPrice}</span>
        </div>}


    </div>
  );
}

export default ExpressOption;
